import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 4D49A420-B80E-48FA-A331-A556002EA46F
 * name home-city
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-city.svg
 * tags
 * - Home Automation 
 */
export const HomeCityIcon = createSvgIcon(<><path d="M0,21V10L7.5,5L15,10V21H10V14H5V21H0M24,2V21H17V8.93L16,8.27V6H14V6.93L10,4.27V2H24M21,14H19V16H21V14M21,10H19V12H21V10M21,6H19V8H21V6Z" /></>, 'HomeCityIcon');
export default HomeCityIcon